import Base from './base'

/**
 * The Loan Committee Report's exhibit endpoints. One module rather than one per
 * exhibit: they are all `due-diligence/:id/*` routes serving the same page, and
 * a file each left the api surface fragmented as the LCR grew.
 *
 * Methods are `verbNoun` (the dueDiligence module's convention) because several
 * resources share this class.
 */
export default class Lcr extends Base {
  // ── Existing Debt ─────────────────────────────────────────────────────────

  listExistingDebt(id: string) {
    return this.apiClient.get(`due-diligence/${id}/existing-debt`)
  }

  createExistingDebt(id: string, data: object) {
    return this.apiClient.post(`due-diligence/${id}/existing-debt`, data)
  }

  updateExistingDebt(id: string, debtId: string, data: object) {
    return this.apiClient.patch(`due-diligence/${id}/existing-debt/${debtId}`, data)
  }

  deleteExistingDebt(id: string, debtId: string) {
    return this.apiClient.delete(`due-diligence/${id}/existing-debt/${debtId}`)
  }

  // ── Inventory Appraisal ───────────────────────────────────────────────────

  getInventoryAppraisal(id: string) {
    return this.apiClient.get(`due-diligence/${id}/inventory-appraisal`)
  }

  uploadInventoryAppraisal(id: string, file: File) {
    const formData = new FormData()
    formData.append('files[file]', file, file.name)
    return this.apiClient.post(`due-diligence/${id}/inventory-appraisal`, formData)
  }

  // ── Board Members ─────────────────────────────────────────────────────────

  listBoardMembers(id: string) {
    return this.apiClient.get(`due-diligence/${id}/lcr-board-members`)
  }

  addBoardMember(id: string, data: object) {
    return this.apiClient.post(`due-diligence/${id}/lcr-board-members`, data)
  }

  updateBoardMember(id: string, memberId: string, data: object) {
    return this.apiClient.patch(`due-diligence/${id}/lcr-board-members/${memberId}`, data)
  }

  deleteBoardMember(id: string, memberId: string) {
    return this.apiClient.delete(`due-diligence/${id}/lcr-board-members/${memberId}`)
  }
}
